// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const defaultEnvironment = {
  production: false,
  allowManageSubscription: false,
  enableManualAccountLinking: true,
  subscriptionCustomFields: [],
  themeFields: [],
  firstNameId: '',
  lastNameId: '',
  birthdayId: '',
  uwg7Id: '',
  doiId: '',
  title: '', // title of browser tab
  favicon: '',
  backToShopLink: '',
  useCustomUnsubscriptionButton: false,
  customUnsubscriptionButtonLink: '',
  allowChangePaymentMethod: false,
  backendBaseUrl: 'http://localhost:6677/customer-portal/v1',
  clientId: 'angular-local',
  realmId: 'cover',
  authUrl: 'https://sso.stage.covernet.de/auth',
  logo: 'cover.png',
  customerStyleSheet: 'cover.css',
  customer: 'Cover',
  company: 'Cover Softwarelösungen GmbH & Co. KG',
  ordersLinks: {
    subscriptions: {
      html: undefined,
    },
    single: {
      html: undefined,
    },
  },
  footer: { header: undefined, leftFooter: [], rightFooter: [] } as Footer,
  onlineSubscriptionCustomTittle: undefined,
  onlineSubscriptionLink: '' as string | OnlineSubscriptionUrl[], // external web reader URL(s), single URL string leads to immediate redirect, multiple lead to another sub component/page
  digitalContent: false, // enables internal article download view for digital subscriptions
  sepaAgreement_de:
    'Ich ermächtige den Verlag (nachfolgend "Gläubiger") widerruflich, Zahlungen von meinem Konto mittels Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut an, die vom Gläubiger auf mein Konto gezogenen Lastschriften einzulösen.\n' +
    '\n' +
    'Ich bin damit einverstanden, dass der Gläubiger meine Daten (insbesondere Name, Kontonummer, Bankleitzahl) zum Zwecke der Durchführung der SEPA-Lastschrift und für die Abwicklung der Zahlungsvorgänge speichert.\n' +
    '\n' +
    'Mir ist bekannt, dass ich diese Einwilligung jederzeit widerrufen kann. Der Widerruf erfolgt über das aktuelle Kundenportal, in welchem ich mich momentan befinde, unter dem Bereich "Zahlungsarten". Ein Widerruf hat keine Auswirkungen auf bereits erfolgte Zahlungen, wirkt jedoch für die Zukunft.',
  sepaConditions_de:
    'Ich habe die Allgemeinen Geschäftsbedingungen sowie die Datenschutzerklärung des Unternehmens gelesen und stimme diesen ausdrücklich zu.',
  customerServiceEmail: '',
  customerServicePhone: '',
  linkToFAQ: '',
  useCustomTranslation: false,
  translationFolder: '',
  customCancellationLink: null,
  maxPaymentMethodsAllowed: null,
  revocationCustomLink: null,
  features: {
    groups: {
      create: false,
      read: false,
      update: false,
      delete: false,
    },
    complaint: false,
    cancellation: true,
    revocation: false,
    invoiceDownload: true,
    complaintInUserAddress: false,
    paymentMethods: true,
    footer: {
      lined: false,
    },
  },
}

export interface OnlineSubscriptionUrl {
  label: string
  info?: string
  url: string
}

export interface Footer {
  header: string | undefined
  leftFooter: FooterObject[]
  rightFooter: FooterObject[]
}

export interface FooterObject {
  header: string
  elements: FooterElement[]
}

interface FooterElement {
  type: 'link' | 'text' | 'html'
  textToDisplay: string | undefined
  html: string | undefined
  linkHref: string | undefined
}

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
